export enum WebhookRequestTypeEnum {
  DEFAULT = 'DEFAULT',
  INTEGRATION = 'INTEGRATION',
}
